export default __webpack_public_path__ + "static/media/WorkWork-hover.4beb3b01.svg";